import { render, staticRenderFns } from "./col.vue?vue&type=template&id=eb00ebde&"
import script from "./col.vue?vue&type=script&lang=js&"
export * from "./col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb00ebde')) {
      api.createRecord('eb00ebde', component.options)
    } else {
      api.reload('eb00ebde', component.options)
    }
    module.hot.accept("./col.vue?vue&type=template&id=eb00ebde&", function () {
      api.rerender('eb00ebde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/col/col.vue"
export default component.exports